jQuery(function($)
{
    var $body = $('body');
    var $select = $('#elements-per-page');
    var allowedValues = ['24', '48', '96'];

    if (0 === $select.length)
    {
        return;
    }

    function init()
    {
        var elementsPerPage = Cookies.get('elementsPerPage');

        if (typeof elementsPerPage != 'undefined' && $.inArray(elementsPerPage, allowedValues))
        {
            $select.val(elementsPerPage);
        }
    }

    function setCookie(elementsPerPage)
    {
        Cookies.set('elementsPerPage', elementsPerPage);
    }

    function handleChange()
    {
        var elementsPerPage = $(this).val();

        if ($.inArray(elementsPerPage, allowedValues) > -1)
        {
            setCookie(elementsPerPage);
        }
        else
        {
            console.log('Invalid value for elementsPerPage cookie. Allowed values are: ' + allowedValues.join(', '));
        }

        $body.addClass('processing');

        location.reload();
    }

    init();

    $select.on('change', handleChange);
});
